import type React from "react";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: string | number;
  height?: string | number;
}

export const Image: React.FC<ImageProps> = ({ src, alt, width, height, ...rest }) => (
  // eslint-disable-next-line react/forbid-elements
  <img alt={alt} decoding="async" height={height} loading="lazy" src={src} width={width} {...rest} />
);
